import script from "./DualListBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./DualListBox.vue?vue&type=script&setup=true&lang=ts"

import "./DualListBox.vue?vue&type=style&index=0&id=900868b4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-900868b4"]])

export default __exports__